<template>
  <div id="ecommerce-slider" class="ecommerce-slider donate-carousel">
    <VueSlickCarousel v-bind="settings" class="slides-container">
      <div
        v-for="(image, i) of images"
        :key="i"
        class="product-slide"
        :class="i > 0 ? 'slide-sub' : 'slide-main'"
      >
        <img :src="image" alt="product" />
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "EcommerceSlider",
  components: {
    VueSlickCarousel,
  },

  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        infinite: true,
        responsive: [
          {
            breakpoint: 5000,
            settings: "unslick",
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.product-slide {
  padding: 10px 10px;
}

.product-slide img {
  pointer-events: none;
}

.slide-sub {
  width: 33%;
}

.slide-main {
  width: 100%;
  text-align: center;
}

.ecommerce-slider >>> button.slick-arrow.slick-prev,
.ecommerce-slider >>> button.slick-arrow.slick-next,
.ecommerce-slider >>> button.slick-arrow.slick-prev:hover,
.ecommerce-slider >>> button.slick-arrow.slick-next:hover {
  width: 3rem;
  height: 3rem;
  background: var(--wwfWhite);
}
.ecommerce-slider >>> button.slick-arrow.slick-prev {
  left: 2rem;
}
.ecommerce-slider >>> button.slick-arrow.slick-next {
  right: 2rem;
}

@media only screen and (min-width: 601px) {
  .slides-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
    background: none;
  }
  .ecommerce-slider {
    margin: 0 -10px;
  }
}
</style>


// WEBPACK FOOTER //
// EcommerceSlider.vue?d790d0a8